import loggingService from '@/services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'caseService'
var path = '/Case/'
var isDebug = false

const CaseTypeEnum = {
    homicide: 1,
    suicide: 2,
    accident: 3,
    natural: 4,
    undetermined: 5,
    aoa: 6,
    pending: 7
}

const MannerOfDeathEnum = {
    accident: 2,
    suicide: 3,
    homicide: 4,
    pendingInv: 5,
    undetermined: 6,
    natural: 8
}

const LocationOfDeathTypeEnum = {
    hospitalInpatient: 1,
    hospitalOutpatient: 2,
    hospitalDoa: 3,
    decedentHome: 4,
    hospice: 5,
    nursingHome: 6,
    other: 7,
    assistedLiving: 8
}

function put (http, dto) {
    loggingService.log(isDebug, serviceName, 'put')
    //serialize datetime
    dto.coronerNotifiedDate = dateService.dateTimeStringToMoment(dto.coronerNotifiedDateString, dto.coronerNotifiedTimeString)
    dto.decedentDeathDate = dateService.dateTimeStringToMoment(dto.decedentDeathDateString, dto.decedentDeathTimeString)
    dto.injuryDate = dateService.dateTimeStringToMoment(dto.injuryDateString, dto.injuryTimeString)
    dto.foundDeadDate = dateService.dateTimeStringToMoment(dto.foundDeadDateString, dto.foundDeadTimeString)
    dto.lastSeenAliveDate = dateService.dateTimeStringToMoment(dto.lastSeenAliveDateString, dto.lastSeenAliveTimeString)
    dto.pronouncedDeadDate = dateService.dateTimeStringToMoment(dto.pronouncedDeadDateString, dto.pronouncedDeadTimeString)
    dto.nextOfKinNotifiedDate = dateService.dateTimeStringToMoment(dto.nextOfKinNotifiedDateString, dto.nextOfKinNotifiedTimeString)
    dto.placedInCoolingDate = dateService.dateTimeStringToMoment(dto.placedInCoolingDateString, dto.placedInCoolingTimeString)
    dto.funeralHomePickupDate = dateService.dateTimeStringToMoment(dto.funeralHomePickupDateString, dto.funeralHomePickupTimeString)
    return http.put(path + 'Put', dto)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?caseId=' + id).then(response => {
        //console.log(response.data)
        if (response.data) {
            //parse datetime into dateString and timeString
            dateService.parseDateTimeToIndivStrings(response.data)
            response.data.decedentDateOfBirth = dateService.convertToDateString(response.data.decedentDateOfBirth)
            response.data.autopsyPerformedDate = dateService.convertToDateString(response.data.autopsyPerformedDate)
        }
        return response
    }).catch(error => {
        throw error
    })
}

function search (http, dto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Search', dto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDateString(x.createdDate)
                x.deathDate = dateService.convertToDateString(x.deathDate)
            })
        }
        return response
    })
}

// function sendVssDeathData (http, caseId) {
//     return http.put(path + 'SendVssDeathData?caseId=' + caseId)
// }

function fileAsPendingToVss (http, caseId) {
    return http.put(path + 'FileAsPendingToVss?caseId=' + caseId)
}

function caseDoNotSendToVss (http, caseId, doNotSend) {
    return http.put(path + `CaseDoNotSend?caseId=${caseId}&doNotSend=${doNotSend}`)
}

function linkCaseToVss (http, caseId, deathId, copyRecord) {
    return http.put(path + `LinkCaseToVss?caseId=${caseId}&deathId=${deathId}&copyRecord=${copyRecord}`)
}

function validateSimilarRecordsToVss (http, caseId) {
    return http.post(path + 'ValidateSimilarRecordsToVss?caseId=' + caseId)
}

function searchSimilarRecords (http, caseId) {
    return http.post(path + 'SearchSimilarRecords?caseId=' + caseId).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDateString(x.createdDate)
            })
        }
        return response
    })
}

function removePendingStatus (http, caseId) {
    return http.put(path + 'RemovePendingStatus?caseId=' + caseId).then(response => {
        if (response.data) {
            return response
        }
    })
}

function getRejectionNotes (http, caseId) {
    return http.get(path + 'GetRejectionNotes?caseId=' + caseId).then(response => {
        if (response.data) {
            return response
        }
    })
}

function getVssDeathMediaList (http, caseId) {
    return http.get(path + 'GetVssDeathMediaList?caseId=' + caseId).then(response => {
        if (response.data) {
            return response
        }
    })
}

function getVssDeathMedia (http, caseId, vssMediaId) {
    return http.get(path + `GetVssDeathMedia?caseId=${caseId}&vssMediaId=${vssMediaId}`, { responseType: 'arraybuffer' })
}

function genBurialTransitPermit (http, caseId, permitSelection) {
    console.log(permitSelection)
    return http.get(path + `GenBurialTransitPermit?caseId=${caseId}&permitSelection=${permitSelection}`, { responseType: 'arraybuffer' })
}

export default {
    put: put,
    get: get,
    search: search,
    //sendVssDeathData: sendVssDeathData
    fileAsPendingToVss: fileAsPendingToVss,
    caseDoNotSendToVss: caseDoNotSendToVss,
    validateSimilarRecordsToVss: validateSimilarRecordsToVss,
    searchSimilarRecords: searchSimilarRecords,
    linkCaseToVss: linkCaseToVss,
    removePendingStatus: removePendingStatus,
    getRejectionNotes: getRejectionNotes,
    getVssDeathMediaList: getVssDeathMediaList,
    getVssDeathMedia: getVssDeathMedia,
    genBurialTransitPermit: genBurialTransitPermit,
    CaseTypeEnum: CaseTypeEnum,
    MannerOfDeathEnum: MannerOfDeathEnum,
    LocationOfDeathTypeEnum: LocationOfDeathTypeEnum
}
